import { AttachFile } from "@mui/icons-material";
import { Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { Employee } from "../types/processTypes";

type Props = {
  employee: Employee;
  onOpenScreenshot: (employee: Employee) => void;
  /** When false, show empty/dash for not-held instead of null (mobile card vs table). */
  showDashWhenEmpty?: boolean;
};

export function MusanedPlacedCell({
  employee,
  onOpenScreenshot,
  showDashWhenEmpty = false,
}: Props) {
  if (!employee.additionalData?.musanedHeld) {
    if (showDashWhenEmpty) {
      return (
        <Typography color="text.secondary" variant="body2">
          —
        </Typography>
      );
    }
    return null;
  }

  const hasScreenshot = Boolean(
    employee.additionalData?.musanedHeldScreenshot,
  );

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Chip
        label="Placed"
        color="error"
        size="small"
        sx={{ fontWeight: 700 }}
      />
      <Tooltip
        title={
          hasScreenshot
            ? "View or change Musaned screenshot"
            : "Attach Musaned screenshot"
        }
      >
        <IconButton
          size="small"
          color={hasScreenshot ? "primary" : "default"}
          onClick={(e) => {
            e.stopPropagation();
            onOpenScreenshot(employee);
          }}
          aria-label="Musaned screenshot"
        >
          <AttachFile fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
